import firebase from 'firebase';
import router from '../router';
import axios from 'axios';

export default {
    initialize({ dispatch }) {
        dispatch('messageTypeRead');
        dispatch('messageGroupRead');
        dispatch('messageRead');
        dispatch('employeeRead');
        dispatch('locationRead');
    },
    userRegister({ dispatch, commit }, { formData }) {
        firebase
            .auth()
            .createUserWithEmailAndPassword(formData.email, formData.password)
            .then(data => {
                let displayName = formData.firstName + ' ' + formData.lastName;
                data.user.updateProfile({ displayName: displayName });

                let employeeData = {
                    fbUid: data.user.uid,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    location: formData.location
                };
                dispatch('employeeCreate', { employeeData: employeeData });

                dispatch('initialize');

                commit('setFbUser', data.user);
                commit('setIsAuthenticated', true);
                router.push('/');
            });
    },
    userLogin({ dispatch, commit }, { email, password }) {
        firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then(data => {
                dispatch('initialize');

                commit('setFbUser', data.user);
                commit('setIsAuthenticated', true);
                router.push('/');
            })
            .catch(loginError => {
                commit('setFbUser', null);
                commit('setIsAuthenticated', false);
                console.error(
                    'Error: ' + loginError.message + ' ' + loginError.code
                );
            });
    },
    userLogout({ commit }) {
        firebase
            .auth()
            .signOut()
            .then(() => {
                commit('setFbUser', null);
                commit('setIsAuthenticated', null);
                router.push('/login');
            })
            .catch(() => {
                commit('setFbUser', null);
                commit('setIsAuthenticated', null);
                router.push('/login');
            });
    },
    async sendMail(
        { state },
        { messageGroupId, messageSender, messageSubject }
    ) {
        try {
            let response = await axios.post(
                `${state.internalApi.sendMailApi + '/send'}`,
                {
                    action: 'send',
                    messageGroupId: messageGroupId,
                    messageSender: messageSender,
                    messageSubject: messageSubject
                }
            );

            if (response.data['status'] == 'success') {
                // TODO: Trigger some notification that message was sent
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Could not create message');
        }
    },
    async messageCreate({ state, dispatch, getters }, { formData }) {
        formData.messageSender = formData.user;
        formData.user = getters.getEmployeeByFbUid(state.user.fbUser.uid).uid;
        try {
            let response = await axios.post(
                `${state.internalApi.messageApi + '/create'}`,
                {
                    formData
                }
            );

            if (response.data['status'] == 'success') {
                dispatch('sendMail', {
                    messageGroupId: formData.messageGroup.uid,
                    messageSender: formData.messageSender,
                    messageSubject: formData.subject
                });
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Could not create message');
            console.error(error);
        }
    },
    async messageRead({ state, commit }) {
        try {
            let response = await axios.get(
                `${state.internalApi.messageApi + '/read'}`,
                {
                    params: {}
                }
            );
            commit('setMessages', response.data);
        } catch (error) {
            commit('setMessages', {});
        }
    },
    async messageUpdate({ state, dispatch }, { formData }) {
        try {
            await axios.post(`${state.internalApi.messageApi + '/update'}`, {
                formData
            });
            dispatch('messageRead');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Could not update message');
        }
    },
    async messageTypeRead({ state, commit }) {
        try {
            let response = await axios.get(
                `${state.internalApi.messageTypeApi + '/read'}`,
                {
                    params: {}
                }
            );
            commit('setMessageTypes', response.data);
        } catch (error) {
            commit('setMessageTypes', {});
        }
    },
    async messageGroupRead({ state, commit }) {
        try {
            let response = await axios.get(
                `${state.internalApi.messageGroupApi + '/read'}`,
                {
                    params: {}
                }
            );
            commit('setMessageGroups', response.data);
        } catch (error) {
            commit('setMessageGroups', {});
        }
    },
    async locationRead({ state, commit }) {
        try {
            let response = await axios.get(
                `${state.internalApi.locationApi + '/read'}`,
                {
                    params: {}
                }
            );
            commit('setLocations', response.data);
        } catch (error) {
            commit('setLocations', {});
        }
    },
    async employeeCreate({ state, dispatch }, { employeeData }) {
        try {
            await axios.post(`${state.internalApi.employeeApi + '/create'}`, {
                employeeData
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Could not create employee');
        }
    },
    async employeeRead({ state, commit }) {
        try {
            let response = await axios.get(
                `${state.internalApi.employeeApi + '/read'}`,
                {
                    params: {}
                }
            );
            commit('setEmployees', response.data);
        } catch (error) {
            commit('setEmployees', {});
        }
    }
};
